import { Modal } from '@components/Customized';
import { CapaPaymentCancelStatus, Maybe } from '@generated/graphql';

interface CancelReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  cancelStatus: Maybe<CapaPaymentCancelStatus> | undefined;
  cancelReason: string;
  refoundPrice: number;
}

const CancelReasonModal = ({
  isOpen,
  onClose,
  cancelStatus,
  refoundPrice,
  cancelReason
}: CancelReasonModalProps) => {
  const title = getCancelTitle(cancelStatus);
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Modal.Title color="error">{title} 사유</Modal.Title>
      <Modal.CloseButton onClose={onClose} />

      <Modal.ContentSection>
        <Modal.Text variant="body2" color="textSecondary" gutterBottoms={16}>
          총 환불 대금: {Number(refoundPrice).toLocaleString('kr')}원
        </Modal.Text>
        <Modal.Text
          variant="body1"
          color="textPrimary"
          style={{
            wordBreak: 'break-all'
          }}
        >
          {cancelReason}
        </Modal.Text>
      </Modal.ContentSection>
    </Modal>
  );
};

export default CancelReasonModal;

const getCancelTitle = (cancelStatus?: Maybe<CapaPaymentCancelStatus>) => {
  if (CapaPaymentCancelStatus.RejectOrderByPartner === cancelStatus) {
    return '발주서 거절';
  }
  if (CapaPaymentCancelStatus.CancelRequested === cancelStatus) {
    return '결제 취소';
  }
  if (CapaPaymentCancelStatus.RefundRequested === cancelStatus) {
    return '환불 요청';
  }
  return null;
};
